import StakeConfirmation from "./StakeConfirmation";

export default StakeConfirmation;
